import React, {useContext, useState} from "react";
import {Dialog, DialogActions, DialogTitle, DialogContentText, DialogContent, Button, TextField} from "@mui/material";
import ReportContext from "../../context/ReportContext";
import {useAddPageToTrackerMutation} from "../../store/slice/myContentDashAdminApi";

type NewPageTrackerDialogProps = {
    onClose: (value: string) => void;
    open: boolean;
}

const NewPageTrackerDialog = ({onClose, open}: NewPageTrackerDialogProps) => {
    const {report} = useContext(ReportContext);
    const [newTrackerName, setNewTrackerName] = useState<string>();

    const closeAndClean = (cancel: boolean) => {
        if(cancel) {
            onClose(null);
        }
        else {
            onClose(newTrackerName);
        }
        setNewTrackerName("");
    }
    return <Dialog
        open={open}
        onClose={() => closeAndClean(true)}
    >
        <DialogTitle>Create New Tracker</DialogTitle>
        <DialogContent>
        <DialogContentText>Create a new page tracker to monitor them in the Tracked Pages tab</DialogContentText>
        <TextField
            autoFocus
            margin="dense"
            label="Title"
            value={newTrackerName}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNewTrackerName(event.target.value);
            }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeAndClean(true)}>Cancel</Button>
          <Button type="submit" onClick={ () => closeAndClean(false)}>Create</Button>
        </DialogActions>
    </Dialog>
}

export default NewPageTrackerDialog;